<sz-app-shell>
  <sz-top-bar />

  @if (draft() === undefined) {
    <div class="session-active__skeleton">
      <sz-skeleton shape="text" width="45%" height="14px" />
      <sz-skeleton shape="text" width="65%" height="28px" />
      <sz-skeleton shape="block" height="220px" />
    </div>
  } @else if (sessionDrill(); as sd) {
    <div class="session-active">
      <header class="session-active__title-block">
        <div class="session-active__top-row">
          @if (hasPreviousDrill()) {
            <button type="button" class="session-active__prev" (click)="goToPreviousDrill()">
              <sz-icon name="arrow-back" [size]="12" />
              <span class="session-active__prev-label">
                {{ 'session.active.previousDrillCta' | translate }}
                @if (previousDrillName(); as prev) {
                  <span class="session-active__prev-name">· {{ prev }}</span>
                }
              </span>
            </button>
          } @else {
            <span class="session-active__top-spacer"></span>
          }
          <sz-button variant="danger-ghost" size="sm" (click)="confirmAbort()">
            {{ 'session.active.endButton' | translate }}
          </sz-button>
        </div>

        <div class="session-active__meta">
          <span class="session-active__live">
            <sz-live-dot />
            {{ 'common.sessionActiveBadge' | translate }}
          </span>
          <span class="session-active__sep">·</span>
          <span class="session-active__drill-name">{{ sd.drillName }}</span>
          <span class="session-active__sep">·</span>
          <span class="session-active__scoring">{{ scoringLabels[sd.scoring] }}</span>
        </div>

        <h2 class="session-active__run-title">
          {{ 'session.active.runHeading' | translate }}
          <span class="session-active__run-current">{{ currentRunLabel() }}</span>
          @if (sd.targetRuns !== null) {
            <em class="session-active__run-total">/{{ sd.targetRuns }}</em>
          }
        </h2>

        @if (sd.targetRuns !== null) {
          <lib-session-progress-indicator [current]="currentRunIndex()" [target]="sd.targetRuns" />
        }
      </header>

      @if (sd.planNote !== null || sd.drillDescription !== null) {
        <div class="session-active__notes">
          @if (sd.drillDescription !== null) {
            <div class="session-active__note">
              <div class="session-active__note-label">{{ 'session.active.drillDescriptionLabel' | translate }}</div>
              <p class="session-active__note-body">{{ sd.drillDescription }}</p>
            </div>
          }
          @if (sd.planNote !== null) {
            <div class="session-active__note">
              <div class="session-active__note-label">{{ 'session.active.planNoteLabel' | translate }}</div>
              <p class="session-active__note-body">{{ sd.planNote }}</p>
            </div>
          }
        </div>
      }

      <div class="session-active__body">
        @switch (sd.scoring) {
          @case (scoring.RepsOnly) {
            <lib-reps-only-run-entry [sessionDrill]="sd" />
          }
          @case (scoring.TimePerRep) {
            <lib-time-per-rep-run-entry [sessionDrill]="sd" />
          }
          @case (scoring.HitFactor) {
            <lib-hit-factor-run-entry [sessionDrill]="sd" />
          }
        }
      </div>
    </div>

    <sz-cta-bar variant="floating">
      <sz-button variant="primary" [fullWidth]="true" (click)="finishCurrentDrill()">
        {{ 'session.active.finishDrillCta' | translate }}
        <sz-icon name="arrow-right" [size]="16" />
      </sz-button>
    </sz-cta-bar>
  } @else {
    <div class="session-active__empty">
      <p>{{ 'session.active.noActiveSession' | translate }}</p>
      <sz-button variant="primary" (click)="abortDiscard()">{{ 'common.back' | translate }}</sz-button>
    </div>
  }
</sz-app-shell>
